import React from 'react'
import { useField, FieldHookConfig } from 'formik'

import ErrorMessage from '@/components/formik/messages/ErrorMessage'
import RadioGroupInput, { RadioGroupInputProps } from '@/components/ui/inputs/RadioGroupInput'

type TextFieldProps = FieldHookConfig<string> & RadioGroupInputProps

const MemoizedRadioGroupInput = React.memo(RadioGroupInput)

export function RadioGroupField(props: TextFieldProps) {
  const [field, meta] = useField<string>(props)

  return (
    <MemoizedRadioGroupInput
      {...props}
      error={!!meta.error && meta.touched}
      helperText={!!meta.error && meta.touched && (
        <ErrorMessage error={meta.error} />
      )}
      onBlur={field.onBlur}
      onChange={field.onChange}
      value={field.value}
    />
  )
}

export default RadioGroupField